var _defs, _title, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _polygon, _polygon2, _polygon3, _path96, _path97, _polygon4, _path98, _path99, _polygon5, _polygon6, _polygon7, _polygon8, _path100, _polygon9, _polygon10, _polygon11, _path101, _path102, _polygon12, _path103, _path104, _ellipse, _ellipse2, _ellipse3, _ellipse4, _polyline, _polyline2, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _ellipse5, _path243, _path244, _path245, _ellipse6, _path246, _path247, _path248;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBanKharPage = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "77.54mm",
    height: "119.91mm",
    viewBox: "0 0 219.81 339.89",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    x: 0,
    y: 224.84,
    width: 112.54,
    height: 104.86,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-63.84 -74.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.9,345.8c-2.74.07-7.25,11-9.11,13.2-4.73,5.59-14.64,13.4-22.44,10.78a15,15,0,0,1-6.42-4.93c-5.61-6.72-8.57-15.12-10.4-23.58-1.74-8.07-1.62-16.55-6.24-23.72a8.67,8.67,0,0,0-3.5-3.42c-5.53-2.48-9.51,4-11,8.32-5.52,15.8-6,32.91-4.58,49.44-.74-8.68,2.23-18.18,4.08-26.55,1.71-7.74,2.42-16.2,6.87-23,6.34,14,6.68,31,11.65,45.66,3.18,9.37,8,16.08,18.75,15.54,8.65-.43,16.85-4.25,23.82-9.4a112.94,112.94,0,0,0,15.36-14.37c1.91-2.06,9.87-14.17,11.66-14.2l-18.48.24",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 95.11,
    y1: 329.97,
    x2: 95.11,
    y2: 285.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#b71c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#911c24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 135.34,
    y1: 329.97,
    x2: 135.34,
    y2: 285.31,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    transform: "translate(-63.84 -74.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.5,178.93c0-.76.06-1.52.06-2.28,0-27.2-22.71-46.94-48.63-46.94s-48.55,19.21-48.55,46.41c0,.95,0,1.89.09,2.84h-.09l.16,1a51.26,51.26,0,0,0,1.53,9.09l7.19,42.61c1.42,8.44,6.58,14.82,13.47,20.54a50.77,50.77,0,0,0,11.51,7.38,56.2,56.2,0,0,0,6.46,2.41h0a18.07,18.07,0,0,0,1.79.47c.6.14,1.18.25,1.73.32a32.73,32.73,0,0,0,9.56,0,20,20,0,0,0,3.34-.66,31.15,31.15,0,0,0,4.35-1.45h0c1.2-.46,2.19-.89,2.74-1.13a50.77,50.77,0,0,0,11.51-7.38c6.89-5.72,12-12.1,13.47-20.54,3-17.56,5.36-35.15,8.33-52.71Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    transform: "translate(-63.84 -74.55)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.45,
    y: 126.04,
    width: 132.63,
    height: 94.43,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h",
    transform: "translate(-63.84 -74.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.51,201.34c-1.08-7.58-5.91-13.78-10.67-13.1s-7.66,8-6.58,15.56,5.82,13.18,10.59,12.5S243.59,208.93,242.51,201.34Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i",
    transform: "translate(-63.84 -74.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.33,201.34c1.08-7.58,5.91-13.78,10.67-13.1s7.66,8,6.58,15.56S125.76,217,121,216.31,113.25,208.93,114.33,201.34Z",
    fill: "none"
  })))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "work-1")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 113.93,
    cy: 106.68,
    r: 88.55,
    fill: "none",
    stroke: "#bb2025",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 113.64,
    cy: 106.38,
    r: 72.4,
    fill: "none",
    stroke: "#bb2025"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.64,
    cy: 106.38,
    r: 53.89,
    fill: "none",
    stroke: "#bb2025"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 113.53,
    cy: 106.28,
    r: 105.78,
    fill: "none",
    stroke: "#bb2025",
    opacity: 0.41,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.9,345.8c-2.74.07-7.25,11-9.11,13.2-4.73,5.59-14.64,13.4-22.44,10.78a15,15,0,0,1-6.42-4.93c-5.61-6.72-8.57-15.12-10.4-23.58-1.74-8.07-1.62-16.55-6.24-23.72a8.67,8.67,0,0,0-3.5-3.42c-5.53-2.48-9.51,4-11,8.32-5.52,15.8-6,32.91-4.58,49.44-.74-8.68,2.23-18.18,4.08-26.55,1.71-7.74,2.42-16.2,6.87-23,6.34,14,6.68,31,11.65,45.66,3.18,9.37,8,16.08,18.75,15.54,8.65-.43,16.85-4.25,23.82-9.4a112.94,112.94,0,0,0,15.36-14.37c1.91-2.06,9.87-14.17,11.66-14.2l-18.48.24",
    transform: "translate(-63.84 -74.55)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.31,358.78,74,365.38c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77,358.61,73.7,365.2c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86,363.1l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.68,362.93l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3L77,358.61Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,367.42,91.45,374c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.38,367.25l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.43,371.74l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.09,371.57l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.14,376.06l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.8,375.89l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.84,380.37l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.51,380.21l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.55,384.69l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.21,384.53l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.26,389l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.92,388.84l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147,393.33l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M146.63,393.16l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.37,355.46l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84,355.3l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3L75.33,351Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93.08,359.78l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.74,359.62l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3L84,355.3Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.79,364.1l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.45,363.93l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.5,368.42l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M110.16,368.25l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.2,372.74l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M118.87,372.57l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.91,377.06l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127.57,376.89l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.62,381.38l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M136.28,381.21,133,387.8c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.33,385.7l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M145,385.53l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.74,347.83l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4,347.66l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.44,352.15l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M91.11,352l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.15,356.47l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M99.81,356.3l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3L91.11,352Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.86,360.79l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M108.52,360.62l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.57,365.11l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M117.23,364.94,114,371.53c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.27,369.43,123,376c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M125.94,369.26l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135,373.75l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M134.64,373.58l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.69,378.06l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M143.35,377.9l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.4,382.38l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M152.06,382.22l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.81,344.52l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M89.47,344.35l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3L80.76,340Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.51,348.84l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M98.17,348.67l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.22,353.15l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M106.88,353l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.93,357.47l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M115.59,357.31l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.63,361.79l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M124.3,361.62,121,368.21c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.34,366.11l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M133,365.94l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142,370.43l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M141.71,370.26l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.76,374.75l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M150.42,374.58l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.17,336.88l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M87.83,336.72l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.88,341.2l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M96.54,341l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.58,345.52l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M105.24,345.35,102,351.94c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3L96.54,341Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.29,349.84l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M114,349.67l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123,354.16l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M122.66,354l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.71,358.48l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M131.37,358.31l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.41,362.8l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M140.07,362.63l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.12,367.12l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M148.78,366.95l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M157.83,371.43l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M157.49,371.27l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.24,333.57,92,340.17c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9,333.4,91.63,340c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.94,337.89l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M103.61,337.72l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.65,342.21l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M112.31,342,109,348.62c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.36,346.52l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M121,346.36l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.07,350.84l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M129.73,350.68l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.77,355.16l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M138.43,355l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.48,359.48l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M147.14,359.31l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.19,363.8l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M155.85,363.63l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93.6,325.93l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M93.26,325.77,90,332.35c-2.26,4.55-7.4,4-7.4,4S79,332.58,81.29,328l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.31,330.25,99,336.86c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M102,330.09l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111,334.57l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M110.68,334.4,107.41,341c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.72,338.89l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M119.38,338.72l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.43,343.21l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M128.09,343l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.14,347.53l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M136.8,347.36l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.84,351.85l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M145.5,351.68l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.55,356.17l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M154.21,356l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.26,360.49l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M162.92,360.32l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.67,322.62l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M100.33,322.45,97.06,329c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.37,326.94l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M109,326.77l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.08,331.26l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M117.74,331.09l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.79,335.58l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M126.45,335.41,123.18,342c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.5,339.9l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M135.16,339.73l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.2,344.21l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M143.87,344l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.91,348.53l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M152.57,348.37,149.31,355c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.62,352.85l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M161.28,352.68,158,359.27c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99,315l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M98.69,314.82l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3L90,310.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.74,319.31l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M107.4,319.14l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.44,323.62l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M116.11,323.46,112.84,330c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.15,327.94l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M124.81,327.78l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.86,332.26l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M133.52,332.09l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142.57,336.58l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M142.23,336.41,139,343c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.27,340.9,148,347.5c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M150.94,340.73l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160,345.22l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M159.64,345.05l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.69,349.54l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M168.35,349.37,165.08,356c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.1,311.67l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M105.76,311.5l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.8,316l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M114.47,315.82l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.51,320.31l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M123.17,320.14l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.22,324.63l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M131.88,324.46,128.61,331c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.93,328.95l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M140.59,328.78l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.63,333.27l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M149.3,333.1,146,339.68c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.34,337.58l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M158,337.42,154.74,344c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167,341.9l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M166.71,341.74l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.46,304l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M104.12,303.87l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.17,308.36l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M112.83,308.19l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.87,312.68l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M121.54,312.51l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.58,317l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M130.24,316.83,127,323.41c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.29,321.31l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M139,321.15l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148,325.63l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M147.66,325.46,144.39,332c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.7,330l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M156.37,329.78l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M165.41,334.27l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M165.07,334.1l-3.27,6.59c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M174.12,338.59l-3.27,6.6c-2.43,4.9-8,4.29-8,4.29s-3.84-4-1.41-8.94l3.27-6.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M173.78,338.42,170.51,345c-2.26,4.55-7.4,4-7.4,4s-3.56-3.75-1.31-8.3l3.27-6.59Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "104.86 285.31 96.71 310.12 100.78 314.73 96.71 329.97 90.68 329.97 92.81 309.76 85.36 285.31 104.86 285.31",
    fill: "url(#b)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "125.59 285.31 133.75 310.12 129.67 314.73 133.75 329.97 139.77 329.97 137.64 309.76 145.09 285.31 125.59 285.31",
    fill: "url(#c)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "173.08 176.48 116.2 176.48 115.3 176.48 58.42 176.48 61.26 195.27 64.8 210.87 80.4 251.98 81.82 261.2 81.82 287.08 115.3 287.08 116.2 287.08 149.69 287.08 149.69 261.2 151.1 251.98 166.7 210.87 170.25 195.27 173.08 176.48",
    fill: "#b71c24"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M161.61,411.6,145,414.44s-6-.71-2.13-6.38l11.7-3.54h6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#9b1b28"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M196.68,411.6l16.66,2.84s6-.71,2.13-6.38l-11.7-3.54h-6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#9b1b28"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "85.39 178.38 150.17 181.76 150.95 226.03 126.15 253.95 95.54 252.51 78.82 221.36 85.39 178.38",
    fill: "none"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M202.8,254.61H156C140.9,297.06,179.42,326,179.42,326,188.17,317.26,216.51,294.57,202.8,254.61Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#fff"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M171.3,257.06l-.38-.86a14.29,14.29,0,0,1,1.77-1.58h1.75Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#595352"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "110.58 233.8 117.06 238.83 119 235.2 105.55 224.75 110.58 233.8",
    fill: "#6b6461"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "115.26 242.21 116.39 240.1 112.33 236.95 115.26 242.21",
    fill: "#6b6461"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "103.31 220.74 103.79 221.6 119.67 233.93 121.54 230.41 104.46 217.15 103.31 220.74",
    fill: "#6b6461"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "112.91 180.07 108.04 183.85 107.46 182.52 110.6 180.07 112.91 180.07",
    fill: "#fff5d5"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M190.26,293.39l-1.94-6.49-.69-2.33L186,279.1h0l0-.16-.26-.89-.7-2.33h0l-2.43-8h0l2.67-5.9,1.25-2.76,1.14-2.5a12,12,0,0,0-1.91-1.93h-8.94l-4.87,3.78,1.65,3.81.58,1.34,1.65,3.81.17.38-.49,1.66-.22.75L174,274l-.46,1.43-1.28,4-.46,1.43-1.29,4L170,286.3l-1.27,4,17.29,13.43,1.87-3.5.67-1.26,1.9-3.57.22-.42Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#d12629"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "104.46 217.15 121.54 230.41 122.22 229.15 104.92 215.72 104.46 217.15",
    fill: "#fff5d5"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "105.55 224.75 119 235.2 119.67 233.93 103.79 221.6 105.55 224.75",
    fill: "#fff5d5"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "112.33 236.95 116.39 240.1 117.06 238.83 110.58 233.8 112.33 236.95",
    fill: "#fff5d5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M153.24,251.25s-4.29,10.34-4.29,10.34l28.46,66.87,3.76-.4c.07-5.26.22-31.15.22-31.15C166,293.69,153.24,251.25,153.24,251.25Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#c3bebc"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M204.48,251.25l5.63,7.16-30,69.66-3.61.34c-.07-5.26-.21-30.17-.21-30.17C193.49,291.77,204.48,251.25,204.48,251.25Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#aaa6a4"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "146.26 179.33 123.61 176.7 115.75 180.26 107.89 176.7 85.24 179.33 95.15 199.04 115.75 180.7 136.36 199.04 146.26 179.33",
    fill: "#c5cbcb",
    style: {
      mixBlendMode: "multiply"
    }
  }), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "146.26 177.82 123.61 176.7 115.75 179.99 107.89 176.7 85.24 177.82 95.15 197.53 115.75 180.26 136.36 197.53 146.26 177.82",
    fill: "#fff"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M178.94,328.34s-24.71-56.95-20.38-77.09h-12s-3.43,5.87-3.88,9.92c0,0,5.79,5.76,7,5.39l-10.51,5c8.47,26.58,39.92,57.68,38.52,59.64A7.11,7.11,0,0,0,178.94,328.34Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#9b1b28"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M178.44,328.34s24.71-56.95,20.38-77.09h12s3.43,5.87,3.88,9.92c0,0-5.79,5.76-7,5.39l10.51,5c-.9,11.26-30.3,49.75-37.85,57.92a11.09,11.09,0,0,1-3.81,2.85S177.53,330.25,178.44,328.34Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#9b1b28"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.26,
    cy: 226.26,
    rx: 1.86,
    ry: 1.77,
    fill: "#767371"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.26,
    cy: 239.27,
    rx: 1.86,
    ry: 1.78,
    fill: "#767371"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.94,
    cy: 263.49,
    rx: 2.6,
    ry: 2.59,
    fill: "#4e4f50"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.94,
    cy: 272.2,
    rx: 2.6,
    ry: 2.59,
    fill: "#4e4f50"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "168.91 177.63 172.92 169.89 181.42 166.05 174.34 165.03 167.33 138.36 173.25 132.34 200.35 162.63 190.87 190.91 167.78 196.81",
    fill: "#b71c24"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "60.2 177.63 56.19 169.89 47.69 166.05 54.77 165.03 61.78 138.36 55.86 132.34 28.76 162.63 38.25 190.91 61.34 196.81",
    fill: "#b71c24"
  })), /*#__PURE__*/React.createElement("image", {
    width: 170,
    height: 191,
    transform: "translate(30 33.9)",
    opacity: 0.38,
    xlinkHref: "data:image/png;base64,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",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.13,258.28v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V258.28Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M187.55,258.28v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162.81,247.93v12.64c0,9.38-8.92,12.66-8.92,12.66S145,269.94,145,260.56V247.93Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M162.23,247.93v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.5,247.93v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V247.93Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M178.92,247.93v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.19,247.93v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V247.93Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M195.61,247.93v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.88,247.93v12.64c0,9.38-8.92,12.66-8.92,12.66S195,269.94,195,260.56V247.93Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M212.3,247.93v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.75,237.58v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V237.58Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M154.17,237.58v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V237.58h16.69Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.44,237.58v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V237.58Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M170.86,237.58v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V237.58h16.69Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.13,237.58v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V237.58Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M187.55,237.58v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V237.58h16.69Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.82,237.58v12.64c0,9.38-8.92,12.66-8.92,12.66S187,259.59,187,250.21V237.58Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M204.24,237.58v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V237.58h16.69Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.94,237.58v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V237.58Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M220.36,237.58v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V237.58h16.69Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.69,227.23v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V227.23Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M146.12,227.23v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162.81,227.23v12.64c0,9.38-8.92,12.66-8.92,12.66S145,249.24,145,239.86V227.23Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M162.23,227.23v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.5,227.23v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V227.23Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M178.92,227.23v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.19,227.23v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V227.23Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M195.61,227.23v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.88,227.23v12.64c0,9.38-8.92,12.66-8.92,12.66S195,249.24,195,239.86V227.23Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M212.3,227.23v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.57,227.23v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V227.23Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M229,227.23v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.75,216.87v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V216.87Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M154.17,216.87v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.44,216.87v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V216.87Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M170.86,216.87v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.13,216.87v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V216.87Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M187.55,216.87v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.82,216.87v12.64c0,9.38-8.92,12.66-8.92,12.66S187,238.89,187,229.51V216.87Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M204.24,216.87v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.94,216.87v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V216.87Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M220.36,216.87v12.5C220.36,238,212,241,212,241s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.69,205.95v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V205.95Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M146.12,206.52V219c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162.81,205.95v12.64c0,9.38-8.92,12.66-8.92,12.66S145,228,145,218.59V205.95Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M162.23,206.52V219c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.5,205.95v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V205.95Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M178.92,206.52V219c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.19,205.95v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V205.95Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M195.61,206.52V219c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.88,205.95v12.64c0,9.38-8.92,12.66-8.92,12.66S195,228,195,218.59V205.95Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M212.3,206.52V219c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.57,205.95v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V205.95Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M229,206.52V219c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.36,216.31v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V216.31Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M120.79,216.31V228.8c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5h16.69Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.05,216.31v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V216.31Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M137.48,216.31V228.8c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5h16.69Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.74,216.31v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V216.31Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M154.17,216.31V228.8c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5h16.69Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.43,216.31v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V216.31Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M170.86,216.31V228.8c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5h16.69Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.55,216.31v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V216.31Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M187,216.31V228.8c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5H187Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.24,216.31v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V216.31Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M203.66,216.31V228.8c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5h16.69Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.93,216.31v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V216.31Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M220.35,216.31V228.8c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5h16.69Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.62,216.31v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V216.31Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M237,216.31V228.8c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5H237Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.31,216.31v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V216.31Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M253.73,216.31V228.8c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5h16.69Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.42,206v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V206Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M128.84,206v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V206Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.11,206v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V206Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M145.53,206v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V206Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162.8,206v12.64c0,9.38-8.92,12.66-8.92,12.66S145,228,145,218.59V206Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M162.22,206v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V206Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.49,206v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V206Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M178.91,206v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V206Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.18,206v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V206Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M195.6,206v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V206Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.87,206v12.64c0,9.38-8.92,12.66-8.92,12.66S195,228,195,218.59V206Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M212.29,206v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V206Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.56,206v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V206Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M229,206v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V206Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.68,206v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V206Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M245.1,206v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V206Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.36,195v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V195Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M120.79,195.6v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V195.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.05,195v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V195Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M137.48,195.6v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V195.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.74,195v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V195Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M154.17,195.6v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V195.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.43,195v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V195Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M170.86,195.6v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V195.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.55,195v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V195Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M187,195.6v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V195.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.24,195v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V195Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M203.66,195.6v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V195.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.93,195v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V195Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M220.35,195.6v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V195.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.62,195v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V195Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M237,195.6v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V195.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.31,195v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V195Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M253.73,195.6v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V195.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.42,184.68v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V184.68h17.84Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M128.84,184.68v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.11,184.68v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V184.68h17.84Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M145.53,184.68v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162.8,184.68v12.64c0,9.38-8.92,12.66-8.92,12.66S145,206.7,145,197.32V184.68H162.8Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M162.22,184.68v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.49,184.68v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V184.68h17.84Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M178.91,184.68v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.18,184.68v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V184.68h17.84Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M195.6,184.68v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.87,184.68v12.64c0,9.38-8.92,12.66-8.92,12.66S195,206.7,195,197.32V184.68h17.84Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M212.29,184.68v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.56,184.68v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V184.68h17.84Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M229,184.68v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.68,184.68v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V184.68h17.84Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M245.1,184.68v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.36,174.33V187c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V174.33Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M120.79,174.33v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.05,174.33V187c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V174.33Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M137.48,174.33v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.74,174.33V187c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V174.33Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M154.17,174.33v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.43,174.33V187c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V174.33Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M170.86,174.33v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.55,174.33V187c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V174.33Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M187,174.33v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.24,174.33V187c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V174.33Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M203.66,174.33v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.93,174.33V187c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V174.33Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M220.35,174.33v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.62,174.33V187c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V174.33Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M237,174.33v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.31,174.33V187c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V174.33Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M253.73,174.33v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.42,164v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V164Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M128.84,164v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V164Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.11,164v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V164Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M145.53,164v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V164Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162.8,164v12.64c0,9.38-8.92,12.66-8.92,12.66S145,186,145,176.61V164Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M162.22,164v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V164Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.49,164v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V164Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M178.91,164v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V164Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.18,164v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V164Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M195.6,164v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V164Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.87,164v12.64c0,9.38-8.92,12.66-8.92,12.66S195,186,195,176.61V164Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M212.29,164v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V164Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.56,164v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V164Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M229,164v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V164Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.68,164v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V164Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M245.1,164v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V164Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.36,153.63v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V153.63Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M120.79,153.63v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.05,153.63v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V153.63Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M137.48,153.63v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.74,153.63v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V153.63Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M154.17,153.63v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.43,153.63v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V153.63Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M170.86,153.63v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.55,153.63v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V153.63Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M187,153.63v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.24,153.63v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V153.63Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M203.66,153.63v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.93,153.63v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V153.63Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M220.35,153.63v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.62,153.63v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V153.63Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M237,153.63v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.31,153.63v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V153.63Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M253.73,153.63v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.42,143.28v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V143.28Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M128.84,143.28v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V143.29h16.69Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.11,143.28v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V143.28Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M145.53,143.28v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V143.29h16.69Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162.8,143.28v12.64c0,9.38-8.92,12.66-8.92,12.66S145,165.29,145,155.91V143.28Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M162.22,143.28v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V143.29h16.69Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#8a724a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.49,143.28v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V143.28Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M178.91,143.28v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V143.29h16.69Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.18,143.28v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V143.28Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M195.6,143.28v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V143.29H195.6Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.87,143.28v12.64c0,9.38-8.92,12.66-8.92,12.66S195,165.29,195,155.91V143.28Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M212.29,143.28v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V143.29h16.69Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.56,143.28v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V143.28Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M229,143.28v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V143.29H229Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.68,143.28v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V143.28Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M245.1,143.28v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65V143.29H245.1Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.36,132.93v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V132.93Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M120.79,132.93v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.05,132.93v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V132.93Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M137.48,132.93v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.74,132.93v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V132.93Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M154.17,132.93v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.43,132.93v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V132.93Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M170.86,132.93v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.55,132.93v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V132.93Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M187,132.93v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.24,132.93v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V132.93Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M203.66,132.93v12.5c0,8.63-8.35,11.65-8.35,11.65S187,154,187,145.42v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.93,132.93v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V132.93Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M220.35,132.93v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.62,132.93v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V132.93Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M237,132.93v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.31,132.93v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V132.93Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M253.73,132.93v12.5c0,8.63-8.35,11.65-8.35,11.65S237,154,237,145.42v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.42,122.58v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V122.58Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M128.84,122.58v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.11,122.58v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V122.58Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M145.53,122.58v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162.8,122.58v12.64c0,9.38-8.92,12.66-8.92,12.66S145,144.59,145,135.21V122.58Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M162.22,122.58v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.49,122.58v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V122.58Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M178.91,122.58v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.18,122.58v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V122.58Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M195.6,122.58v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.87,122.58v12.64c0,9.38-8.92,12.66-8.92,12.66S195,144.59,195,135.21V122.58Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M212.29,122.58v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.56,122.58v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V122.58Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M229,122.58v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#a18357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.68,122.58v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V122.58Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M245.1,122.58v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.36,111.65v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V111.65Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M120.79,112.23v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.05,111.65v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V111.65Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M137.48,112.23v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.74,111.65v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V111.65Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M154.17,112.23v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.43,111.65v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V111.65Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M170.86,112.23v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.55,111.65v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V111.65Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M187,112.23v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.24,111.65v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V111.65Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M203.66,112.23v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.93,111.65v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V111.65Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M220.35,112.23v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.62,111.65v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V111.65Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M237,112.23v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.31,111.65v12.64c0,9.38-8.92,12.66-8.92,12.66s-8.92-3.28-8.92-12.66V111.65Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M253.73,112.23v12.5c0,8.63-8.35,11.65-8.35,11.65s-8.35-3-8.35-11.65v-12.5Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#b99664"
  })))), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M224.47,162.68c.12,0-1.85-7.7-9.39-18.39a34.77,34.77,0,0,0-7.83-8.43c-11.54-9.65-28-10.7-46-5.06l-.08,0c-7.84,2.91-16.12,7.6-23.74,1.17a31.72,31.72,0,0,0,3.94,13.32h0c-10,11-10.93,20.86-10.93,20.86,6.42-12.31,15.87-14.65,15.87-14.65v0c4.42,4,11,6.92,21,6.56a76.89,76.89,0,0,0,10-1.41,56.74,56.74,0,0,0,7.5-2.08c5.83-2.07,8.89-4.18,15.21-5C214.88,147.75,224.47,162.68,224.47,162.68Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#262322"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.94,206.64l.71,8.45c.53,6.28-5.29,9-5.29,9s-6.19-1.69-6.72-8l-.71-8.45Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M240.51,206.67l.71,8.43c.49,5.82-4.91,8.33-4.91,8.33s-5.75-1.57-6.24-7.39l-.71-8.43Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.78,200.1l.71,8.45c.53,6.28-5.29,9-5.29,9s-6.19-1.69-6.72-8l-.71-8.45Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M234.35,200.13l.71,8.43c.49,5.82-4.91,8.33-4.91,8.33s-5.75-1.57-6.24-7.39l-.71-8.43Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.93,199.16l.71,8.45c.53,6.28-5.29,9-5.29,9s-6.19-1.69-6.72-8l-.71-8.45Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M245.5,199.2l.71,8.43c.49,5.82-4.91,8.33-4.91,8.33s-5.75-1.57-6.24-7.39l-.71-8.43Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M228.18,193.59l.71,8.43c.49,5.82-4.91,8.33-4.91,8.33s-5.75-1.57-6.24-7.39l-.71-8.43Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M239.76,192.62l.71,8.45c.53,6.28-5.29,9-5.29,9s-6.19-1.69-6.72-8l-.71-8.45Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M239.33,192.66l.71,8.43c.49,5.82-4.91,8.33-4.91,8.33s-5.75-1.57-6.24-7.39l-.71-8.43Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.6,186.08l.71,8.45c.53,6.28-5.29,9-5.29,9s-6.19-1.69-6.72-8l-.71-8.45Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M233.17,186.11l.71,8.43c.49,5.82-4.91,8.33-4.91,8.33s-5.75-1.57-6.24-7.39l-.71-8.43Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244.75,185.14l.71,8.45c.53,6.28-5.29,9-5.29,9s-6.19-1.69-6.72-8l-.71-8.45Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M244.32,185.18l.71,8.43c.49,5.82-4.91,8.33-4.91,8.33s-5.75-1.57-6.24-7.39l-.71-8.43Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.58,178.6l.71,8.45c.53,6.28-5.29,9-5.29,9s-6.19-1.69-6.72-8l-.71-8.45Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M238.15,178.64l.71,8.43c.49,5.82-4.91,8.33-4.91,8.33s-5.75-1.57-6.24-7.39l-.71-8.43Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.9,206.64l-.71,8.45c-.53,6.28,5.29,9,5.29,9s6.19-1.69,6.72-8l.71-8.45Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M116.33,206.67l-.71,8.43c-.49,5.82,4.91,8.33,4.91,8.33s5.75-1.57,6.24-7.39l.71-8.43Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.06,200.1l-.71,8.45c-.53,6.28,5.29,9,5.29,9s6.19-1.69,6.72-8l.71-8.45Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M122.5,200.13l-.71,8.43c-.49,5.82,4.91,8.33,4.91,8.33s5.75-1.57,6.24-7.39l.71-8.43Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.91,199.16l-.71,8.45c-.53,6.28,5.29,9,5.29,9s6.19-1.69,6.72-8l.71-8.45Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M111.35,199.2l-.71,8.43c-.49,5.82,4.91,8.33,4.91,8.33s5.75-1.57,6.24-7.39l.71-8.43Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M128.66,193.59,128,202c-.49,5.82,4.91,8.33,4.91,8.33s5.75-1.57,6.24-7.39l.71-8.43Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#323031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.08,192.62l-.71,8.45c-.53,6.28,5.29,9,5.29,9s6.19-1.69,6.72-8l.71-8.45Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M117.51,192.66l-.71,8.43c-.49,5.82,4.91,8.33,4.91,8.33s5.75-1.57,6.24-7.39l.71-8.43Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.24,186.08l-.71,8.45c-.53,6.28,5.29,9,5.29,9s6.19-1.69,6.72-8l.71-8.45Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M123.68,186.11l-.71,8.43c-.49,5.82,4.91,8.33,4.91,8.33s5.75-1.57,6.24-7.39l.71-8.43Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.09,185.14l-.71,8.45c-.53,6.28,5.29,9,5.29,9s6.19-1.69,6.72-8l.71-8.45Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M112.53,185.18l-.71,8.43c-.49,5.82,4.91,8.33,4.91,8.33s5.75-1.57,6.24-7.39l.71-8.43Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.26,178.6l-.71,8.45c-.53,6.28,5.29,9,5.29,9s6.19-1.69,6.72-8l.71-8.45Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#231f20",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M118.69,178.64l-.71,8.43c-.49,5.82,4.91,8.33,4.91,8.33s5.75-1.57,6.24-7.39l.71-8.43Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#4d4d4f"
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.91,
    cy: 196.2,
    rx: 19.6,
    ry: 17.96,
    transform: "translate(-93.66 -47.83) rotate(-9.32)",
    fill: "#4a4a4c"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M150.24,208.94c7-1.15,11.81-7.29,10.76-13.69s-7.59-10.67-14.57-9.53-11.81,7.29-10.76,13.69S143.25,210.09,150.24,208.94Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#f2eded"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M131,189.38s14.49-3.57,36.71,11.21c0,0,6.25-19.51-15.28-22.89C152.45,177.71,138.79,174.69,131,189.38Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#957950"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M167.25,202s-25.67,12.41-37.1-10.41c0,0-6.88,18.81,15.24,23.2C145.38,214.79,161.86,216.61,167.25,202Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#957950"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.78,
    cy: 196.2,
    rx: 17.96,
    ry: 19.6,
    transform: "translate(-82.5 295.89) rotate(-80.68)",
    fill: "#4a4a4c"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M207.48,208.8c-6.9-1.13-11.66-7.19-10.62-13.51s7.49-10.54,14.39-9.41,11.66,7.2,10.63,13.51S214.37,209.93,207.48,208.8Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#f2eded"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M226.67,189.38S212.18,185.81,190,200.6c0,0-6.25-19.51,15.28-22.89C205.24,177.71,218.89,174.69,226.67,189.38Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#957950"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M190.44,202s25.67,12.41,37.1-10.41c0,0,6.88,18.81-15.24,23.2C212.31,214.79,195.83,216.61,190.44,202Z",
    transform: "translate(-63.84 -74.55)",
    fill: "#957950"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBanKharPage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ban-khar-page.ac0ad6cf.svg";
export { ForwardRef as ReactComponent };